import type { BaseComponentConfig, SlotGameStore } from "@gamzix/slot_core";
import { CONST } from "../../../src/const";
import { PaytableWinningSchemes } from "./PaytableWinningSchemes";

class UIComponent extends SlotGame.src.component.UIComponent {

  wrapperSchema;  

  public onGameReady() {
    super.onGameReady();

    this.wrapperSchema = game.tree.findByName("ui.menu.paytable.wrapper_payLines_schema");
    PaytableWinningSchemes.createAndAdd(this.wrapperSchema);
  }

  public onInfoClick() {
    super.onInfoClick();
    this.getFixWidthJapanTextPaytable();
  }

  public onRulesClick() {
    super.onRulesClick();
    this.getFixWidthJapanTextRules();
    this.getFixWidthPolandTextRules();
  }


  constructor(config: BaseComponentConfig) {
    super(config);

    const store = <SlotGameStore>game.store;

    this.text_checkers = {
      ...super.getTextCheckers(),
      GET_SYMBOL_COUNT_PAYOUT_X: (element) => {
        const { symbol, count } = element.options.data;
        const payout = store.gameRules.getSymbolPayouts(symbol)[count - 1];
        const payInCent = store.gameData.bet * payout;

        return `x${count} - ${store.toFormatMoney(payInCent)}`;
      },

      POSITIONS_NUMBER: () => CONST.COLUMNS * CONST.ROWS,
      RTP_VALUE: () => "96%",

      PJ_VALUE: () => 5000,
      GJ_VALUE: () => 150,
      SJ_VALUE: () => 50,
      BJ_VALUE: () => 20,

      PJ_VALUE_DYNAMIC: () => store.toFormatMoney(store.gameData.bet * CONST.JACKPOT.PLATINUM.multiplier),
      GJ_VALUE_DYNAMIC: () => store.toFormatMoney(store.gameData.bet * CONST.JACKPOT.GOLD.multiplier),
      SJ_VALUE_DYNAMIC: () => store.toFormatMoney(store.gameData.bet * CONST.JACKPOT.SILVER.multiplier),
      BJ_VALUE_DYNAMIC: () => store.toFormatMoney(store.gameData.bet * CONST.JACKPOT.BRONZE.multiplier),

      GAME_NAME: () => game.env.gameName
    }
  }

  setMobilePortraitConfigTextWidth(elementName, maxWidth = 1030, positionX = 0) {
    const elementObj = game.tree.findByName(elementName);
    if (elementObj === undefined) {
      throw console.error(`game.tree.findByName: ${elementName} --- undefined`);
    }

    if (positionX) {
      //Set position.x + width
      elementObj.options.layout.mobile_portrait["wordWrap"] = false;
      elementObj.options.layout.mobile_portrait["width"] = maxWidth;
      elementObj.options.layout.mobile_portrait["position"]["x"] = positionX;

    } else {
      //Set width
      elementObj.options.layout.mobile_portrait["wordWrap"] = false;
      elementObj.options.layout.mobile_portrait["width"] = maxWidth;
    }
  }

  getFixWidthJapanTextPaytable() {
    const isNotPoloshLanguage: boolean = (<SlotGameStore>game.store).language !== "ja";
    if (isNotPoloshLanguage) return

    this.onChangeOrientation();
  }

  getFixWidthJapanTextRules() {
    const isNotPoloshLanguage: boolean = (<SlotGameStore>game.store).language !== "ja";
    if (isNotPoloshLanguage) return

    // this.setMobilePortraitConfigTextWidth("game_rules.table.button_doubling.descr", 600);
    this.setMobilePortraitConfigTextWidth("game_rules.table.button_auto_play.descr", 600);
    this.setMobilePortraitConfigTextWidth("game_rules.free_spins.buy_descr", 600);
    this.setMobilePortraitConfigTextWidth("game_rules.table.button_switch_bet.descr", 600);
    this.setMobilePortraitConfigTextWidth("game_rules.table.button_icon_menu.descr", 600);
    this.setMobilePortraitConfigTextWidth("game_rules.table.button_settings.descr", 600);
    this.setMobilePortraitConfigTextWidth("game_rules.table.button_paytable.name_value", 150, -300);
    this.setMobilePortraitConfigTextWidth("game_rules.table.button_paytable.descr", 600);
    this.setMobilePortraitConfigTextWidth("game_rules.table.button_rules.descr", 600);
    this.setMobilePortraitConfigTextWidth("game_rules.table.button_close.descr", 600);
    this.setMobilePortraitConfigTextWidth("game_rules.table.button_home.descr", 600);
    this.setMobilePortraitConfigTextWidth("game_rules.table.button_spin.descr", 600);
    this.setMobilePortraitConfigTextWidth("game_rules.table.button_spin.name_value", 200, -265);

    this.onChangeOrientation();
  }

  getFixWidthPolandTextRules() {
    const isNotPoloshLanguage: boolean = (<SlotGameStore>game.store).language !== "pl";
    if (isNotPoloshLanguage) return

    this.setMobilePortraitConfigTextWidth("game_rules.table.button_auto_play.name_value", 200, -255);

    this.onChangeOrientation();
  }

  get store(): SlotGameStore {
    return <SlotGameStore>game.store;
  }
}

//@ts-ignore
Game.src.component.UIComponent = UIComponent;
